/**
 * Shared rules for delivery route / booking UIs (Manage Routes, Booking Details).
 */

export function isDeliveryRouteJobProductionComplete(job: {
  status: string;
  production_status?: string | null;
}): boolean {
  return job.status === 'completed' && job.production_status === 'production_complete';
}

/**
 * Full Booking Details card background + border from delivery_status.
 * Also used for read-only DeliveryDetailsDisplay panels.
 */
export function getDeliveryStatusPanelClassNames(
  status: string | null | undefined,
): string {
  switch (status) {
    case 'confirmed':
      return 'bg-green-100 border-green-300';
    case 'voicemail':
    case 'voicemail_email':
      return 'bg-orange-100 border-orange-300';
    case 'redelivery':
      return 'bg-blue-100 border-blue-300';
    default:
      return 'bg-gray-100 border-gray-300';
  }
}

/** Full card when production is not complete (Booking Details). */
export function getProductionIncompleteCardClassNames(): string {
  return 'bg-red-200 border-red-300 hover:bg-red-300';
}

/**
 * Pill/badge classes for delivery status in read-only display — same palette as full card and Manage Routes.
 */
export function getDeliveryStatusPillClassNames(status: string): string {
  switch (status) {
    case 'confirmed':
      return 'bg-green-200 text-green-900 border-green-300';
    case 'voicemail':
    case 'voicemail_email':
      return 'bg-orange-200 text-orange-900 border-orange-300';
    case 'redelivery':
      return 'bg-blue-200 text-blue-900 border-blue-300';
    default:
      return 'bg-gray-200 text-gray-900 border-gray-300';
  }
}
